import { render, staticRenderFns } from "./portal_menu.vue?vue&type=template&id=c2d23ae0&scoped=true&"
import script from "./portal_menu.vue?vue&type=script&lang=js&"
export * from "./portal_menu.vue?vue&type=script&lang=js&"
import style0 from "./portal_menu.vue?vue&type=style&index=0&id=c2d23ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d23ae0",
  null
  
)

export default component.exports